<template>
  <div class="help-btn-container d-inline-block">
    <Button
      class="help-btn"
      label="?"
      rounded
      size="large"
      @click="openDrawer"
    />
  </div>
</template>

<script setup>
import { inject } from "vue"

const props = defineProps({
  content: {
    type: [Object, String],
    default: () => ({})
  },
  options: {
    type: Object,
    default: () => ({})
  }
})

const drawerService = inject("drawerService")

const openDrawer = () => {
  drawerService.open(props.content, props.options)
}
</script>
